import { DeleteMenuItemData, MenuService } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useDeleteNavigationItem(
  mutationOptions?: UseMutationOptions<void, HttpError, DeleteMenuItemData>,
) {
  return useMutation({
    mutationFn: MenuService.deleteMenuItem,
    ...mutationOptions,
  });
}

export { useDeleteNavigationItem };
